import React from "react";
import { useTranslation } from "react-i18next";

const isValidEmail = (email) => {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return pattern.test(String(email || "").toLowerCase());
};

// Loose phone validation: keep only digits and require at least 7 of them.
// This accepts inputs like "+54 9 11 5555-5555", "(555) 123-4567", "+44 20 7946 0958".
const isValidPhone = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  return digits.length >= 7;
};

const Step1WelcomeOffer = ({ answers, updateAnswers, goNext, onSkip }) => {
  const { t } = useTranslation();

  const handleEmailChange = (event) => {
    updateAnswers({ email: event.target.value });
  };

  const handlePhoneChange = (event) => {
    updateAnswers({ phone: event.target.value });
  };

  const canSubmit =
    isValidEmail(answers.email) && isValidPhone(answers.phone);

  const handleYes = () => {
    if (!canSubmit) {
      return;
    }
    updateAnswers({ wantsApp: true });
    if (typeof goNext === "function") {
      goNext();
    }
  };

  const handleNo = () => {
    updateAnswers({ wantsApp: false });
    if (typeof onSkip === "function") {
      onSkip();
    }
  };

  return (
    <div className="onboarding-step onboarding-step--welcome">
      <h2 className="onboarding-step__title">
        {t("homeModalWelcome.step1.title")}
      </h2>
      <p className="onboarding-step__description">
        {t("homeModalWelcome.step1.description")}
      </p>

      <div className="onboarding-step__email-group">
        <label htmlFor="onboarding-email" className="onboarding-step__label">
          {t("homeModalWelcome.step1.emailLabel")}
        </label>
        <input
          id="onboarding-email"
          type="email"
          className="onboarding-input"
          value={answers.email || ""}
          onChange={handleEmailChange}
          placeholder={t("homeModalWelcome.step1.emailPlaceholder")}
        />
        {answers.email && !isValidEmail(answers.email) && (
          <span className="onboarding-step__error">
            {t("homeModalWelcome.step1.emailError")}
          </span>
        )}
      </div>

      <div className="onboarding-step__email-group">
        <label htmlFor="onboarding-phone" className="onboarding-step__label">
          {t("homeModalWelcome.step1.phoneLabel")}
        </label>
        <input
          id="onboarding-phone"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          className="onboarding-input"
          value={answers.phone || ""}
          onChange={handlePhoneChange}
          placeholder={t("homeModalWelcome.step1.phonePlaceholder")}
        />
        {answers.phone && !isValidPhone(answers.phone) ? (
          <span className="onboarding-step__error">
            {t("homeModalWelcome.step1.phoneError")}
          </span>
        ) : (
          <span className="onboarding-step__hint">
            {t("homeModalWelcome.step1.phoneHint")}
          </span>
        )}
      </div>

      <div className="modal__buttons onboarding-step__inline-buttons">
        <button
          type="button"
          className="close__button modal-button cancel-button"
          onClick={handleNo}
        >
          {t("homeModalWelcome.buttonNo")}
        </button>
        <button
          type="button"
          className="close__button modal-button save-button"
          onClick={handleYes}
          disabled={!canSubmit}
        >
          {t("homeModalWelcome.buttonYes")}
        </button>
      </div>
    </div>
  );
};

// El step 1 maneja sus propios botones (Yes/No) inline al estilo del ModalWelcome
// original, asi que el wizard oculta el footer estandar.
Step1WelcomeOffer.hideFooter = true;

// Mantenido por compatibilidad si alguna vez se quisiera mostrar el footer estandar.
Step1WelcomeOffer.canAdvance = (answers) =>
  answers.wantsApp === true &&
  isValidEmail(answers.email) &&
  isValidPhone(answers.phone);

export default Step1WelcomeOffer;
